"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalizeColor;

var _cssColorNames = _interopRequireDefault(require("./cssColorNames"));

var _hex6ToHex = _interopRequireDefault(require("./hex6ToHex3"));

function normalizeColor(value) {
  var _cssColorNames$get;

  var colorValue = (_cssColorNames$get = _cssColorNames.default.get(value)) !== null && _cssColorNames$get !== void 0 ? _cssColorNames$get : value;

  if (!/^#[0-9a-f]{6}$/i.test(colorValue)) {
    return value.toLowerCase();
  }

  return (0, _hex6ToHex.default)(colorValue.toLowerCase());
}